(() => {
  const DESCRIPTION_KEYWORD = "description";
  const EXTRA_SCROLL_GAP = 100;
  const CLAMP_LINES = 2;

  function textIncludesDescription(text) {
    return (text || "").toLowerCase().includes(DESCRIPTION_KEYWORD);
  }

  function handleize(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");
  }

  function getCandidateIds(targetId) {
    if (!targetId) return [];
    const cleanId = targetId.trim().replace(/^#/, "");
    if (!cleanId) return [];
    const handleizedId = handleize(cleanId);
    const idsToTry = [cleanId];
    if (handleizedId && handleizedId !== cleanId) idsToTry.push(handleizedId);
    return idsToTry;
  }

  function getTopOverlayOffset() {
    let offset = 0;

    const header = document.querySelector(".header");
    if (header) {
      const headerStyle = window.getComputedStyle(header);
      const headerRect = header.getBoundingClientRect();
      if (
        (headerStyle.position === "fixed" || headerStyle.position === "sticky") &&
        headerRect.height > 0 &&
        headerRect.bottom > 0
      ) {
        offset += headerRect.height;
      }
    }

    const stickyCart = document.querySelector(".product__sticky-cart");
    if (stickyCart) {
      const stickyRect = stickyCart.getBoundingClientRect();
      if (stickyRect.height > 0) {
        offset += stickyRect.height;
      }
    }

    return offset + EXTRA_SCROLL_GAP;
  }

  function scrollWithOffset(element) {
    if (!element || element.getClientRects().length === 0) return false;
    const rect = element.getBoundingClientRect();
    const top = Math.max(0, window.scrollY + rect.top - getTopOverlayOffset());
    window.scrollTo({ top, behavior: "smooth" });
    return true;
  }

  function getLineHeight(element) {
    const computedStyle = window.getComputedStyle(element);
    const parsed = parseFloat(computedStyle.lineHeight);
    if (!Number.isNaN(parsed)) return parsed;
    const fontSize = parseFloat(computedStyle.fontSize);
    return Number.isNaN(fontSize) ? 24 : fontSize * 1.5;
  }

  function normalizeText(value) {
    return (value || "").replace(/\s+/g, " ").trim();
  }

  function clampScrollDescription(block) {
    if (!block) return;

    const textElement = block.querySelector("[data-scroll-description-text]");
    const readMore = block.querySelector(".product__scroll-description-read-more");
    const wrapper = block.querySelector(".product__scroll-description-text");
    if (!textElement || !readMore || !wrapper) return;

    const fullText = normalizeText(textElement.dataset.fullText || textElement.textContent);
    if (!fullText) {
      readMore.hidden = true;
      return;
    }

    textElement.dataset.fullText = fullText;
    const maxHeight = getLineHeight(wrapper) * CLAMP_LINES;
    wrapper.style.maxHeight = `${maxHeight}px`;

    textElement.textContent = fullText;
    readMore.hidden = true;

    if (wrapper.scrollHeight <= maxHeight + 1) return;

    readMore.hidden = false;
    let low = 0;
    let high = fullText.length;
    let best = 0;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      const candidate = normalizeText(fullText.slice(0, mid));
      textElement.textContent = candidate ? `${candidate}\u2026` : "";

      if (wrapper.scrollHeight <= maxHeight + 1) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    const finalText = normalizeText(fullText.slice(0, best));
    textElement.textContent = finalText ? `${finalText}\u2026` : "";
  }

  function clampAllScrollDescriptions() {
    document.querySelectorAll(".product__scroll-description-clamp").forEach(clampScrollDescription);
  }

  function findHeadingAnchorByIds(ids) {
    for (const id of ids) {
      const triggerInProductInfo = document.querySelector(`product-tabs .product__tab--trigger[data-tab="${id}"]`);
      if (triggerInProductInfo) return triggerInProductInfo.closest(".product__tabs") || triggerInProductInfo;

      const triggerInSectionTabs = document.querySelector(`.product-tabs__tab[aria-controls="${id}"]`);
      if (triggerInSectionTabs) return triggerInSectionTabs.closest(".product-tabs__tabs") || triggerInSectionTabs;
    }
    return null;
  }

  function activateDescriptionByIds(ids) {
    let activated = false;

    ids.forEach((id) => {
      const triggerInProductInfo = document.querySelector(`product-tabs .product__tab--trigger[data-tab="${id}"]`);
      if (triggerInProductInfo) {
        triggerInProductInfo.click();
        activated = true;
      }

      const triggerInSectionTabs = document.querySelector(`.product-tabs__tab[aria-controls="${id}"]`);
      if (triggerInSectionTabs) {
        triggerInSectionTabs.click();
        activated = true;
      }
    });

    return activated;
  }

  function openDescriptionFallback() {
    const candidates = [
      ...document.querySelectorAll("product-tabs .product__tab--trigger"),
      ...document.querySelectorAll(".product-tabs__tab")
    ];

    const trigger = candidates.find((el) => textIncludesDescription(el.textContent));
    if (!trigger) return null;

    trigger.click();
    return trigger.closest(".product__tabs, .product-tabs__tabs") || trigger;
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-open-description]");
    if (!trigger) return;

    const targetId = trigger.getAttribute("data-description-target-id");
    const ids = getCandidateIds(targetId);

    let anchor = null;

    if (ids.length) {
      activateDescriptionByIds(ids);
      anchor = findHeadingAnchorByIds(ids);
    }

    if (!anchor) {
      anchor = openDescriptionFallback();
    }

    if (!anchor) return;

    setTimeout(() => {
      scrollWithOffset(anchor);
    }, 180);
  });

  let clampResizeTimer = null;
  window.addEventListener("resize", () => {
    window.clearTimeout(clampResizeTimer);
    clampResizeTimer = window.setTimeout(clampAllScrollDescriptions, 120);
  });

  document.addEventListener("DOMContentLoaded", clampAllScrollDescriptions);
  document.addEventListener("shopify:section:load", clampAllScrollDescriptions);
  clampAllScrollDescriptions();
})();
